import React from 'react';

class FileList extends React.Component {
  renderFiles() {
    return this.props.files.map((file, index) => {
      return (
        <li key={`guest-upload-file${index}`} className="guest-upload-file">
          <span className="bff-trash" onClick={() => this.props.removeFile(index)} />
          <p className="guest-upload-filename">{file.filename}</p>
          <img src={file.url} className="guest-upload-file-preview no-select" alt="thumbnail of guest upload image" />
        </li>
      );
    });
  }

  render() {
    return (
      <ul className="guest-upload-files bf-scroll-element">
        {this.renderFiles()}
      </ul>
    );
  }
}

export default FileList;
